import { useCallback, useMemo, useState } from "react";

export function useOnScreen() {
  const [isIntersecting, setIntersecting] = useState(false);
  const [current, setCurrent] = useState<HTMLElement | null>(null);
  const observer = useMemo(
    () =>
      new IntersectionObserver(([entry]) => {
        if (entry) setIntersecting(entry.isIntersecting);
      }),
    []
  );

  const ref = useCallback(
    (node: HTMLElement | null) => {
      if (current) {
        observer.unobserve(current);
      }

      if (node) {
        observer.observe(node);
        setCurrent(node);
      }
    },
    [current, observer]
  );

  return {
    ref,
    current,
    isIntersecting,
  };
}
